export default "__VITE_ASSET__DhEX5fJ0__"